/**
 * @desc 供应商登录
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.SupplierLoginRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/sys/user/login/supplier/login`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
